import { ProductTypeEnum } from "@jasper/client-models";

export default {
  [`${ProductTypeEnum.bridge}_one`]: "Bridge",
  [`${ProductTypeEnum.bridge}_other`]: "Bridges",
  [`${ProductTypeEnum.crown}_one`]: "Couronne",
  [`${ProductTypeEnum.crown}_other`]: "Couronnes",
  [`${ProductTypeEnum.splintedCrown}_one`]: "Couronne solidarisée",
  [`${ProductTypeEnum.splintedCrown}_other`]: "Couronnes solidarisées",
  [`${ProductTypeEnum.veneer}_one`]: "Facette",
  [`${ProductTypeEnum.veneer}_other`]: "Facettes",
  [`${ProductTypeEnum.lay}_one`]: "Inlay/Onlay/Overlay",
  [`${ProductTypeEnum.lay}_other`]: "Inlay/Onlay/Overlay",
  [`${ProductTypeEnum.inlayCore}_one`]: "Inlay-core",
  [`${ProductTypeEnum.inlayCore}_other`]: "Inlay-cores",
  [`${ProductTypeEnum.waxBite}_one`]: "Cire d'occlusion",
  [`${ProductTypeEnum.waxBite}_other`]: "Cires d'occlusion",
  [`${ProductTypeEnum.retentionWire}_one`]: "Fil de contention",
  [`${ProductTypeEnum.retentionWire}_other`]: "Fils de contention",
  [`${ProductTypeEnum.orthoModel}_one`]: "Modèle d'étude orthodontique",
  [`${ProductTypeEnum.orthoModel}_other`]: "Modèles d'étude orthodontique",
  [`${ProductTypeEnum.dentureRepair}_one`]: "Réparation de prothèse amovible",
  [`${ProductTypeEnum.dentureRepair}_other`]:
    "Réparations de prothèse amovible",
  [`${ProductTypeEnum.additionalImpressionForRemovableProsthesis}_one`]:
    "Empreinte supplémentaire pour prothèse amovible",
  [`${ProductTypeEnum.additionalImpressionForRemovableProsthesis}_other`]:
    "Empreintes supplémentaires pour prothèse amovible",
  [`${ProductTypeEnum.implantCrown}_one`]: "Couronne sur implant",
  [`${ProductTypeEnum.implantCrown}_other`]: "Couronnes sur implant",
  [`${ProductTypeEnum.abutment}_one`]: "Pilier",
  [`${ProductTypeEnum.abutment}_other`]: "Piliers",
  [`${ProductTypeEnum.customAbutment}_one`]: "Pilier personnalisé",
  [`${ProductTypeEnum.customAbutment}_other`]: "Piliers personnalisés",
  [`${ProductTypeEnum.inlay}_one`]: "Inlay",
  [`${ProductTypeEnum.inlay}_other`]: "Inlay",
  [`${ProductTypeEnum.onlay}_one`]: "Onlay",
  [`${ProductTypeEnum.onlay}_other`]: "Onlay",
  [`${ProductTypeEnum.overlay}_one`]: "Overlay",
  [`${ProductTypeEnum.overlay}_other`]: "Overlay",
  [`${ProductTypeEnum.postAndCoreRetainedCrown}_one`]:
    "Couronne sur inlay-core",
  [`${ProductTypeEnum.postAndCoreRetainedCrown}_other`]:
    "Couronnes sur inlay-core",
  [`${ProductTypeEnum.implant}_one`]: "Implant",
  [`${ProductTypeEnum.implant}_other`]: "Implants",
  [`${ProductTypeEnum.splint}_one`]: "Gouttière",
  [`${ProductTypeEnum.splint}_other`]: "Gouttières",
  [`${ProductTypeEnum.nightGuard}_one`]: "Gouttière bruxisme",
  [`${ProductTypeEnum.nightGuard}_other`]: "Gouttières bruxisme",
  [`${ProductTypeEnum.bleachingTray}_one`]: "Gouttière de blanchiment",
  [`${ProductTypeEnum.bleachingTray}_other`]: "Gouttières de blanchiment",
  [`${ProductTypeEnum.retainer}_one`]: "Gouttière de contention",
  [`${ProductTypeEnum.retainer}_other`]: "Gouttières de contention",
  [`${ProductTypeEnum.removableDenture}_one`]: "Prothèse amovible",
  [`${ProductTypeEnum.removableDenture}_other`]: "Prothèses amovibles",
  [`${ProductTypeEnum.partialDenture}_one`]: "Prothèse amovible partielle",
  [`${ProductTypeEnum.partialDenture}_other`]: "Prothèses amovibles partielles",
  [`${ProductTypeEnum.fullDenture}_one`]: "Prothèse amovible complète",
  [`${ProductTypeEnum.fullDenture}_other`]: "Prothèses amovibles complètes",
  [`${ProductTypeEnum.fullDentureWaxBite}_one`]: "Cire d'occlusion",
  [`${ProductTypeEnum.fullDentureWaxBite}_other`]: "Cires d'occlusion",
  [`${ProductTypeEnum.immediateDenture}_one`]: "Prothèse amovible immédiate",
  [`${ProductTypeEnum.immediateDenture}_other`]:
    "Prothèses amovibles immédiates",
  [`${ProductTypeEnum.model}_one`]: "Modèle",
  [`${ProductTypeEnum.model}_other`]: "Modèles",
  [`${ProductTypeEnum.richmondCrown}_one`]: "Couronne Richmond",
  [`${ProductTypeEnum.richmondCrown}_other`]: "Couronnes Richmond",
  [`${ProductTypeEnum.splintedCrownImplant}_one`]:
    "Couronne sur implant solidarisée",
  [`${ProductTypeEnum.splintedCrownImplant}_other`]:
    "Couronnes sur implant solidarisées",
  [`${ProductTypeEnum.bridgeImplant}_one`]: "Bridge sur implant",
  [`${ProductTypeEnum.bridgeImplant}_other`]: "Bridges sur implant",
  [`${ProductTypeEnum.bridgePontic}_one`]: "Pontique",
  [`${ProductTypeEnum.bridgePontic}_other`]: "Pontiques",
  [`${ProductTypeEnum.scanOnly}_one`]: "Scan",
  [`${ProductTypeEnum.scanOnly}_other`]: "Scans",
  [`${ProductTypeEnum.spaceMaintainer}_one`]: "Mainteneur d'espace",
  [`${ProductTypeEnum.spaceMaintainer}_other`]: "Mainteneurs d'espace",
  [`${ProductTypeEnum.waxUp}_one`]: "Wax Up",
  [`${ProductTypeEnum.waxUp}_other`]: "Wax Up",
  [`${ProductTypeEnum.addingTeethOnExistingDenture}_one`]:
    "Adjonction de dents",
  [`${ProductTypeEnum.addingTeethOnExistingDenture}_other`]:
    "Adjonctions de dents",
  [`${ProductTypeEnum.customTray}_one`]: "Porte-empreinte individuel",
  [`${ProductTypeEnum.customTray}_other`]: "Porte-empreintes individuels",
  [`${ProductTypeEnum.metalMesh}_one`]:
    "Grille de renfort pour appareil résine",
  [`${ProductTypeEnum.metalMesh}_other`]:
    "Grilles de renfort pour appareil résine",
};
